import { useEffect, useRef } from 'react';
import classNames from 'classnames';
import CTNPagination from '@ctn/ui/components/ctn-pagination';
import type { Notario } from '@/interfaces/strapi';
import { NotariosListItem } from '@/components';

type NotariosListProps = {
	readonly className?: string;
	readonly items: Notario[];
	readonly page: number;
	readonly pageSize: number;
	readonly total: number;
	readonly isLoading?: boolean;
	readonly onPageChange: (newPage: number) => void;
	readonly title?: string;
};

const classNameComponent = 'c-cnm-notarios-list';

export const NotariosList = ({
	className,
	items,
	page,
	pageSize,
	total,
	isLoading = false,
	onPageChange,
	title = 'Notarios',
}: NotariosListProps) => {
	const wrapperClassName = classNames(classNameComponent, className);
	const paginationRef = useRef<any>(null);

	useEffect(() => {
		if (paginationRef.current?.goToPage && typeof page === 'number') {
			paginationRef.current.goToPage(page);
		}
	}, [page]);

	return (
		<section className={wrapperClassName}>
			{isLoading && <p>Cargando...</p>}
			{!isLoading && items.length === 0 && <p>No hay notarios disponibles.</p>}

			{!isLoading && items.length > 0 && (
				<>
					<ul className={`${classNameComponent}__grid`}>
						{items.map((n) => (
							<li key={(n as any).id}>
								<NotariosListItem notario={n} />
							</li>
						))}
					</ul>

					<nav className="c-ctn-pagination u-mt-16" aria-label="Paginación">
						<CTNPagination
							ref={paginationRef}
							pageSize={pageSize}
							totalData={total}
							locales={{
								text1: 'Página',
								text2: 'de',
								text3: 'Mostrando registros {0} de {1}',
							}}
							onPageChange={onPageChange}
						/>
					</nav>
				</>
			)}
		</section>
	);
};
